import {
  setAttr
} from 'redom';

export function setIconClasses(cls, ...headingIcons) {

  for (let icon of headingIcons) {
    setAttr(icon, { class: cls });
  }

}